<template>
  <page-outline>
    <template slot="pageContent">
      <div :class="['content bg-light', { expanded: !isSidebarOpen }]">
        <b-container fluid>

          <!-- TITLE -->
          <div class="content-title">
            <b-row>
              <h1>Digital Credit Transfer</h1>
            </b-row>
            <b-row>
              <span class="subtitle">Sandbox Dashboard</span>
            </b-row>
          </div>

          <b-row>
            <h3>Backend Management</h3>
          </b-row>
          <b-row>
            <span class="subtitle">Administrative tools for VIBAN management and reconciliation</span>
          </b-row>

          <!-- MENU GRID -->
          <div class="menu-grid">
            <div
              v-for="(item, index) in menu"
              :key="index"
              class="menu-card"
              :style="{
                backgroundColor: item.background,
                borderColor: item.border
              }"
              @click="goto(item.url)"
            >
              <div class="menu-icon">
                <i :class="['fa-regular', item.symbol]"></i>
              </div>

              <div class="menu-content">
                <span class="menu-title">{{ item.title }}</span>
                <span class="menu-description">{{ item.content }}</span>
              </div>
            </div>
          </div>

          <b-row>
            <h3>System Overview</h3>
          </b-row>
          <b-row>
            <span class="subtitle">Key metrics and system status</span>
          </b-row>

          <!-- STATS -->
          <div class="stats">
            <div class="stat-card stat-danger">
              <span class="stat-header">
                <i class="fa-light fa-triangle-exclamation"></i>
                Overdue Items
              </span>
              <span class="stat-value">€{{ Number(overdueAmount).toFixed(2) }}</span>
              <span class="stat-sub">{{ overdueOrders }} orders</span>
            </div>

            <div class="stat-card stat-info">
              <span class="stat-header">
                <i class="fa-light fa-calendar-check"></i>
                Not Yet Due
              </span>
              <span class="stat-value">€{{ Number(notYetDueAmount).toFixed(2) }}</span>
              <span class="stat-sub">{{ notYetDueOrders }} orders</span>
            </div>

            <div class="stat-card stat-success">
              <span class="stat-header">
                <i class="fa-light fa-chart-line-up"></i>
                Today's Volume
              </span>
              <span class="stat-value">€{{ Number(reconciledAmount).toFixed(2) }}</span>
              <span class="stat-sub">Total Reconciled</span>
            </div>

            <div class="stat-card stat-purple">
              <span class="stat-header">
                <i class="fa-light fa-square-check"></i>
                Today's Reconciliation
              </span>
              <span class="stat-value">{{ reconciliationCount }}</span>
              <span class="stat-sub">Transactions Matched</span>
            </div>

            <div class="stat-card stat-warning">
              <span class="stat-header">
                <i class="fa-light fa-bolt-lightning"></i>
                Automation Rate
                <a id="info" href="#">
                  <i class="fa-light fa-circle-question"></i>
                </a>
              </span>

              <b-popover
                target="info"
                triggers="hover"
                placement="top"
                custom-class="popover-info"
              >
                <div>Automation Rate</div>
                <span>
                  Percentage of reconciliations completed automatically without
                  manual intervention. Target: &gt;95%.
                </span>
              </b-popover>

              <span class="stat-value">{{ automationRate }}%</span>
              <span class="stat-sub">Auto vs Manual</span>
            </div>
          </div>

        </b-container>
      </div>
    </template>
  </page-outline>
</template>


<script>
import PageOutline from '@/components/common/PageOutline.vue'
import { loadPage } from '@/helpers/routing';

export default {
  name: 'Dashboard',
  components: {
    'page-outline': PageOutline
  },
  data(){
    return {
      menu : [
        {
          "symbol":"fa-database",
          "title":"VIBAN Management",
          "content": "Manage Virtual IBAN allocations and availability",
          "background": "#fff7ed",
          "border": "#fed7aa",
          "url": "/vibanmanagement/"
        },
        {
          "symbol":"fa-circle-check",
          "title":"Reconciliation Ledger",
          "content": "Reconciliation hub with open items",
          "background": "#eff6ff",
          "border": "#bfdbfe",
          "url": "/reconciliationledger/"
        },
        {
          "symbol":"fa-file-magnifying-glass",
          "title":"Transaction Ledger",
          "content": "Complete audit log of all financial movements",
          "background": "#faf5ff",
          "border": "#ddd6fe",
          "url": "/transactionledger/"+null
        },
        {
          "symbol":"fa-calendar-check",
          "title":"Daily Report",
          "content": "View daily reconciliation report and summaries",
          "background": "#eef2ff !important",
          "border": "#c7d2fe",
          "url": "/dailyreport/"
        },
        {
          "symbol":"fa-wave-pulse",
          "title":"Reconciliation Rules",
          "content": "Configure reconciliation rules and system settings",
          "background": "#faf5ff !important",
          "border": "#ddd6fe",
          "url": "/configuration/"
        },
        {
          "symbol":"fa-user-group",
          "title":"User Management",
          "content": "Manage user roles and permissions",
          "background": "#f8f9fa !important",
          "border": "#ebe6e7",
          "url": "/usermanagement/"
        }
      ],
      isSidebarOpen: true,
      automationRate: 0,
      notYetDueAmount: 0,
      reconciledAmount: 0,
      reconciliationCount: 0,
      overdueAmount: 0,
      notYetDueOrders: 0,
      overdueOrders: 0
    }
  },
  created(){
    this.$engine.services.payments.getStats()
    .then(resp => {
      this.automationRate = resp.data.AutomationRate ?? 0
      this.notYetDueAmount = resp.data.NotYetDue ?? 0
      this.reconciledAmount = resp.data.AmountReconciliation ?? 0
      this.reconciliationCount = resp.data.NbReconciliation ?? 0
      this.overdueAmount = resp.data.Overdue ?? 0
      this.overdueOrders = resp.data.NbOverdue ?? 0
      this.notYetDueOrders = resp.data.NbNotYetDue ?? 0
    })
  },
  methods: {
    openModal() {
      this.isModalOpen = true
    },
    goto(url){
      loadPage(this, {url: url})
    }
  }
}
</script>

<style scoped>
/*  layout  */

.content {
  min-height: 90vh;
  overflow: hidden;
}

.content > div {
  /* padding: 0rem 10rem; */
}

.content-title {
  margin: 1.5rem 0rem 2rem 0rem;
}

.subtitle {
  color: #000000a6;
  font-size: 1.1rem;
}

/*  menu grid  */

.menu-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin: 2rem 0rem;
}

.menu-card {
  height: 9rem;
  padding: 1.5rem;
  border-radius: calc(1.5rem - 2px);
  border: 1px solid;
  display: flex;
  cursor: pointer;
  color: #0a0a0a;
}

.menu-card:hover {
  box-shadow: 0 4px 6px -1px #0000001a, 0 2px 4px -2px #0000001a;
}

.menu-icon i {
  font-size: 2rem;
  margin: 0rem 1.5rem 0rem 1rem;
}

.menu-content {
  display: grid;
}

.menu-title {
  font-size: 1.25rem;
}

.menu-description {
  color: #4a5565;
}

/*  stats  */

.stats {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 2rem;
  margin: 2rem 0rem;
}

.stat-card {
  height: 9rem;
  padding: 1.5rem;
  border-radius: calc(1.5rem - 2px);
  border: 1px solid #0000001a;
  display: grid;
  color: #0a0a0a;
}

.stat-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.85rem;
  color: #4a5565;
  text-wrap: nowrap;
}

.stat-header i {
  font-size: 1.5rem;
}

.stat-value {
  font-size: 1.5rem;
  margin: 0.75rem 0rem;
}

.stat-sub {
  font-size: 0.85rem;
  color: #6a7282;
}

/*  stat variants  */

.stat-danger {
  background-color: #fef2f2;
}
.stat-danger i {
  color: #e7000b;
}

.stat-info {
  background-color: #eff6ff;
}
.stat-info i {
  color: #155dfc;
}

.stat-success {
  background-color: #f0fdf4;
}
.stat-success i {
  color: #00a63e;
}

.stat-purple {
  background-color: #faf5ff;
}
.stat-purple i {
  color: #9810fa;
}

.stat-warning {
  background-color: #fffbeb;
}
.stat-warning i {
  color: #e17100;
}

/*  misc  */

.inactive {
  opacity: 0.5;
  pointer-events: none;
}

.rotate {
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

</style>